import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-splash',
    templateUrl: './splash.component.html',
    styleUrls: ['./splash.component.scss'],
    standalone: false
})
export class SplashComponent implements OnInit {

  @Input() finish: boolean = false


  constructor() { 

    // setTimeout(() => {
    //   this.finish = true
    // }, 2000);

  }

  ngOnInit() {}

}
